/**
 * Import des styles
 * ****************************************
 */
import "./sass/main.scss";
import 'aos/dist/aos.css';
/**
 * Import des modules
 * ****************************************
 */

import AOS from 'aos';
import RecipesFilters from "./ts/RecipesFilters";
import Menu from "./ts/Menu";
import VideoPopups from "./ts/VideoPopups";
import Slider from "./ts/Slider";
import TestimonialsSliders from "./ts/TestimonialsSliders";
import RelatedContentSliders from "./ts/RelatedContentSliders";
import MediaLibrary from "./ts/MediaLibrary";

/**
 * Initialisation des modules
 * ******************************
 */
window.onload = () => {
	AOS.init();
	/**
	 * Gestion des filtres de la page "recettes"
	 * ******************************
	 */
	RecipesFilters();

	/**
	 * Gestion des sous-menus
	 * ******************************
	 */
	Menu();

	/**
	 * Gestion des popups "video"
	 * ******************************
	 */
	VideoPopups();

	/**
	 * Gestion des sliders
	 * ******************************
	 */
	Slider();

	/**
	 * Gestion des sliders "témoignages"
	 * ******************************
	 */
	TestimonialsSliders();

	/**
	 * Gestion des sliders "contenu connexe"
	 * ******************************
	 */
	RelatedContentSliders();

	/**
	 * Gestion de la médiathèque
	 * ******************************
	 */
	MediaLibrary();
};
